import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import { getFlagFromStatus, getStatusByFlag } from '../../../../types/boolean-flag';
import type {
  PaddleConfigurationControl,
  PaddleConfigurationFormValues,
} from '../../PaddleConfigurationFormSchema';
import { AUTOMATICALLY_SYNC_INVOICES_OPTIONS } from './constants';

type InvoicesConfigurationSectionProps = {
  control: PaddleConfigurationControl;
  defaultValues: PaddleConfigurationFormValues;
};

export const InvoicesConfigurationSection: FC<InvoicesConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => (
  <ConfigurationSection title="Invoices" iconName="InvoiceListItem">
    <Controller
      name="autoExportInvoices"
      control={control}
      defaultValue={defaultValues.autoExportInvoices}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          title="Choose how to sync approved invoices"
          value={getFlagFromStatus(value)}
          onChange={(selected) => onChange(getStatusByFlag(selected))}
          keyExtractor={(option) => option.value}
          options={AUTOMATICALLY_SYNC_INVOICES_OPTIONS}
        />
      )}
    />
  </ConfigurationSection>
);
